'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _AutoComplete = require('material-ui/AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _DatePicker = require('material-ui/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Select = require('../Select/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Slider = require('material-ui/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _RadioButton = require('material-ui/RadioButton');

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _TimePicker = require('material-ui/TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _Toggle = require('../Toggle/Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _Checkbox = require('../Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FormattableTextField = require('../FormattableTextField/FormattableTextField');

var _FormattableTextField2 = _interopRequireDefault(_FormattableTextField);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import RadioButtonGroup from 'material-ui/RadioButtonGroup';


var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.margin = {
      margin: '10px 20px'
    };

    var style = { margin: 10 };
    _this.containerStyle = props.parentStyle ? (0, _util.merge)(style, props.parentStyle) : style;

    _this.spaces = props.noSpace ? [_react2.default.createElement('br', null), _react2.default.createElement('br', null)] : null;
    _this.title = props.title ? _react2.default.createElement(
      'h3',
      null,
      props.title
    ) : null;

    _this.getField = _this.getField.bind(_this);

    _this.fields = Object.keys(props.fields).map(function (name) {
      return {
        name: name,
        field: (0, _util.merge)(props.fields[name], props.fieldsInfo[name] || {})
      };
    }).map(function (_ref) {
      var name = _ref.name,
          field = _ref.field;
      return {
        name: name,
        field: _this.getField({ name: name, field: field })
      };
    });

    _this.getFields = _this.getFields.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'getFields',
    value: function getFields(fields, fieldsInfo) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var fieldsArray = _step.value;

          for (var i = 0; i < fieldsArray.field.length; i++) {
            if (fieldsArray.field[i].type !== 'br') {
              var _merge = (0, _util.merge)(fields[fieldsArray.name], fieldsInfo[fieldsArray.name] || {}),
                  style = _merge.style,
                  others = _objectWithoutProperties(_merge, ['style']);

              var errorText = fieldsInfo[fieldsArray.name].touched && fieldsInfo[fieldsArray.name].error ? fieldsInfo[fieldsArray.name].error : null;
              fieldsArray.field[i] = _react2.default.cloneElement(fieldsArray.field[i], _extends({
                style: (0, _util.merge)(fieldsArray.field[i].props.style || {}, style || {}),
                errorText: errorText
              }, others));
            }
            result.push(fieldsArray.field[i]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result.reduce(function (a, b) {
        return a.concat(b);
      }, []);
    }
  }, {
    key: 'getField',
    value: function getField(_ref2) {
      var name = _ref2.name,
          field = _ref2.field;

      var componentProps = {};
      var Component = null;
      var style = this.margin;
      if (field.component) {
        Component = field.component;
      } else {
        switch (field.type) {
          case 'toggle':
            style = (0, _util.merge)(style, { maxWidth: 250 });
            Component = _Toggle2.default;
            break;
          case 'checkbox':
            style = (0, _util.merge)(style, { maxWidth: 250 });
            Component = _Checkbox2.default;
            break;
          case 'radio':
            // TODO
            Component = _RadioButton2.default;
            break;
          case 'slider':
            Component = _Slider2.default;
            break;
          case 'time':
            Component = _TimePicker2.default;
            break;
          case 'select':
            Component = _Select2.default;
            break;
          case 'date':
            Component = _DatePicker2.default;
            break;
          case 'autoComplete':
            Component = _AutoComplete2.default;
            break;
          case 'textArea':
            componentProps.multiLine = true;
            Component = _TextField2.default;
            break;
          case 'formattableTextField':
            Component = _FormattableTextField2.default;
            break;
          default:
            Component = _TextField2.default;
        }
      }
      var result = [];
      if (field.newLine) {
        result.push(_react2.default.createElement('br', { key: 'br-' + name }));
      } else {
        style = (0, _util.merge)(style, { display: 'inline-block' });
      }
      result.push(_react2.default.createElement(Component, _extends({}, field, {
        key: name,
        id: name,
        style: field.style ? (0, _util.merge)(style, field.style) : style,
        errorText: field.touched && field.error ? field.error : null
      }, componentProps)));
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          fields = _props.fields,
          fieldsInfo = _props.fieldsInfo,
          zDepth = _props.zDepth,
          parentStyle = _props.parentStyle,
          parentClass = _props.parentClass,
          noSpace = _props.noSpace,
          others = _objectWithoutProperties(_props, ['title', 'fields', 'fieldsInfo', 'zDepth', 'parentStyle', 'parentClass', 'noSpace']);

      return _react2.default.createElement(
        'div',
        {
          style: this.containerStyle,
          className: parentClass
        },
        _react2.default.createElement(
          _Paper2.default,
          _extends({}, others, {
            zDepth: zDepth || 0
          }),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: '16px' } },
            this.title
          ),
          this.getFields(fields, fieldsInfo),
          this.spaces
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  title: _react2.default.PropTypes.string.isRequired,
  fields: _react2.default.PropTypes.array.isRequired,
  fieldsInfo: _react2.default.PropTypes.object,
  noSpace: _react2.default.PropTypes.bool,
  parentStyle: _react2.default.PropTypes.object,
  parentClass: _react2.default.PropTypes.object
};
_class.propTypes = {
  title: '',
  fields: [],
  fieldsInfo: {},
  noSpace: false,
  parentStyle: null,
  parentClass: null
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Form/FormGroup.js
 ** module id = 493
 ** module chunks = 0
 **/